import dayjs from 'dayjs';

export const get12hOfDate = (date) => {
  if (!date) return null;
  // eslint-disable-next-line newline-per-chained-call
  return dayjs(date).hour(12).minute(0).second(0).millisecond(0);
};
export const formatDate = (date, format = 'DD/MM/YYYY') => {
  if (!date) return '';
  return dayjs(date).format(format);
};

export default {
  get12hOfDate,
};
